/*=========================================================================================
  File Name: state.js
  Description: Hub State
  ----------------------------------------------------------------------------------------
  Item Name: Hub State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    isConnected : false,
    orderMessages : []
}